module.exports = __webpack_public_path__ + "img/dq_bj.2436679.png";